import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { PauseCircle } from 'lucide-react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/Button';

export function PauseBanner() {
  const qc = useQueryClient();
  const { data } = useQuery({
    queryKey: ['pause-status'],
    queryFn: api.pauseStatus,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
  const resume = useMutation({
    mutationFn: api.resumeAgents,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['pause-status'] }),
  });

  if (!data?.paused) return null;

  return (
    <div
      role="status"
      data-testid="pause-banner"
      className="mb-4 flex items-center gap-3 rounded-xl border border-warn-border bg-warn-soft px-4 py-3"
    >
      <PauseCircle className="h-4 w-4 text-warn-bold flex-shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="text-[0.875rem] font-semibold text-warn-bold">
          System paused — all automation halted.
        </div>
        <div className="text-[0.75rem] text-warn-bold/80">
          No agents will start new work. In-flight batches continue until done.
        </div>
      </div>
      <Button
        size="sm"
        variant="secondary"
        onClick={() => resume.mutate()}
        disabled={resume.isPending}
      >
        Resume
      </Button>
    </div>
  );
}
